export default __webpack_public_path__ + "static/media/success.ad436f5c.svg";